import { render, staticRenderFns } from "./observing-panel.vue?vue&type=template&id=6d052627&"
import script from "./observing-panel.vue?vue&type=script&lang=js&"
export * from "./observing-panel.vue?vue&type=script&lang=js&"
import style0 from "./observing-panel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
